import { Controller } from "@hotwired/stimulus";

export class LevelController extends Controller {
  static targets = [
    "nameInput",
    "levelInput",
    "nameInputHidden",
    "levelInputHidden",
    "itemsContainer",
  ];
  static values = {
    max: Number,
    min: Number,
  };

  add() {
    const currentItems = this.itemsContainerTarget.children.length;
    const name = this.nameInputTarget.value;
    const level = this.levelInputTarget.value;
    const selectOption = this.levelInputTarget.selectedOptions[0]?.text || "";

    if (this.hasMaxValue && currentItems >= this.maxValue) return;
    if (!(name && level)) return;

    const elementHTML = `<div class="chip__row" data-name="${name}" data-level="${level}">
                              <small class="chip__row--small">${name}: ${selectOption}</small>
                              <button type="button" class="chip__row__btn-remove" data-action="click->level#remove">x</button>
                          </div>`;

    this.itemsContainerTarget.insertAdjacentHTML("beforeend", elementHTML);

    this.updateHiddenFields();

    this.nameInputTarget.value = "";
    this.levelInputTarget.selectedIndex = 0;
    this.nameInputTarget.focus();
  }

  remove(event) {
    const row = event.currentTarget.closest(".chip__row");
    const rows = this.itemsContainerTarget.querySelectorAll(".chip__row");
    if (this.hasMinValue && rows.length == this.minValue) return;

    if (row) {
      row.remove();
      this.updateHiddenFields();
    }
  }

  updateHiddenFields() {
    const rows = this.itemsContainerTarget.querySelectorAll(".chip__row");

    const names = [];
    const levels = [];

    rows.forEach((row) => {
      names.push(row.dataset.name);
      levels.push(row.dataset.level);
    });

    this.nameInputHiddenTarget.value = names.join("||");
    this.levelInputHiddenTarget.value = levels.join("||");
  }
}
